module.exports = __webpack_public_path__ + "img/biopay.f16857bb.svg";